<template>
      <div class="card">
        <div class="card-content">
          <p class="title">
            ¿Qué es esto?
          </p>
          <div class="content">
            <p>Es una aplicación web para colocar recursos geolocalizados en un mapa.</p>
            <p>La idea es crear una aplicación de este tipo por demanda o especialidad.</p>
            <p>Se puede publicar gratuitamente en la nube.</p>
            <p>Más info en <a href="https://github.com/delineas/help-maps-party">está página</a></p>
            <br />
          </div>
        </div>
      </div>
</template>

<script>
export default {
  name: "AboutModal"
};
</script>

<style></style>
